import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabase';

const L = {
  void:     '#08090a',
  carbon:   '#0f1011',
  graphite: '#23252a',
  fog:      '#8a8f98',
  mist:     '#d0d6e0',
  paper:    '#ffffff',
  blue:     '#2563eb',
  blueDim:  '#1d4ed8',
};

const inter = `-apple-system, BlinkMacSystemFont, "Inter", "Segoe UI", Roboto, sans-serif`;

const inputStyle = {
  width: '100%', boxSizing: 'border-box',
  background: 'rgba(255,255,255,0.03)',
  border: `1px solid ${L.graphite}`,
  borderRadius: 6, padding: '10px 12px',
  fontSize: 14, color: L.mist,
  fontFamily: inter, outline: 'none',
  letterSpacing: '-0.011em',
  transition: 'border-color 0.15s',
};

const labelStyle = {
  display: 'block', fontSize: 12, fontWeight: 510,
  color: L.fog, marginBottom: 6,
  letterSpacing: '-0.011em', fontFamily: inter,
};

export default function Registro() {
  const navigate = useNavigate();
  const [paso, setPaso] = useState('form');
  const [form, setForm] = useState({ nombre: '', email: '', password: '', password2: '', nombreEstudio: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    if (!form.nombre.trim()) { setError('Ingresá tu nombre.'); return; }
    if (!form.nombreEstudio.trim()) { setError('Ingresá el nombre de tu estudio.'); return; }
    if (form.password.length < 6) { setError('La contraseña debe tener al menos 6 caracteres.'); return; }
    if (form.password !== form.password2) { setError('Las contraseñas no coinciden.'); return; }

    setLoading(true);
    const { data: yaExiste } = await supabase.rpc('email_registrado', { p_email: form.email.trim().toLowerCase() });
    if (yaExiste) { setError('Este email ya tiene una cuenta.'); setLoading(false); return; }

    const { data, error: signUpError } = await supabase.auth.signUp({
      email: form.email.trim().toLowerCase(),
      password: form.password,
      options: {
        data: { nombre: form.nombre.trim(), nombre_estudio: form.nombreEstudio.trim() },
        emailRedirectTo: `${window.location.origin}/app`,
      },
    });

    if (signUpError) { setError('Error al registrarse: ' + signUpError.message); setLoading(false); return; }
    if (data.session) { navigate('/app'); return; }
    setPaso('confirmar');
    setLoading(false);
  }

  const wrap = {
    minHeight: '100vh', background: L.void,
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    padding: 24, fontFamily: inter,
  };

  const card = {
    width: '100%', maxWidth: 420,
    background: L.carbon,
    border: `0.5px solid ${L.graphite}`,
    borderRadius: 12,
    padding: '36px 32px',
    boxShadow: `rgba(0,0,0,0.6) 0px 4px 32px`,
  };

  const Logo = () => (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 28 }}>
      <img src="/logo.svg" alt="Mi Estudio" width="32" height="32" style={{ objectFit: 'contain', flexShrink: 0 }} />
      <div>
        <div style={{ fontSize: 15, fontWeight: 510, color: L.paper, letterSpacing: '-0.011em' }}>Mi Estudio</div>
        <div style={{ fontSize: 11, color: L.fog, letterSpacing: '-0.011em' }}>Gestión jurídica integral</div>
      </div>
    </div>
  );

  if (paso === 'confirmar') return (
    <div style={wrap}>
      <div style={card}>
        <Logo />
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: 28, marginBottom: 12 }}>📧</div>
          <div style={{ fontSize: 16, fontWeight: 510, color: L.paper, marginBottom: 8, letterSpacing: '-0.011em' }}>Revisá tu email</div>
          <div style={{ fontSize: 13, color: L.fog, lineHeight: 1.7, marginBottom: 24, letterSpacing: '-0.011em' }}>
            Te enviamos un enlace de confirmación a <span style={{ color: L.mist, fontWeight: 510 }}>{form.email}</span>.<br/>
            Hacé clic en el enlace para activar tu cuenta.<br/><br/>
            <span style={{ color: '#fbbf24', background: 'rgba(251,191,36,0.08)', padding: '3px 8px', borderRadius: 4, fontSize: 12 }}>
              Si no lo ves, revisá la carpeta de spam.
            </span>
          </div>
          <button onClick={() => navigate('/')} style={{ background: 'transparent', border: `1px solid ${L.graphite}`, color: L.fog, borderRadius: 6, padding: '10px 20px', fontSize: 13, cursor: 'pointer', fontWeight: 400, fontFamily: inter, letterSpacing: '-0.011em' }}>
            Volver al inicio
          </button>
        </div>
      </div>
    </div>
  );

  return (
    <div style={wrap}>
      <div style={card}>
        <Logo />
        <div style={{ fontSize: 17, fontWeight: 510, color: L.paper, marginBottom: 4, letterSpacing: '-0.011em' }}>Creá tu estudio</div>
        <div style={{ fontSize: 13, color: L.fog, marginBottom: 24, letterSpacing: '-0.011em' }}>15 días de prueba · Cancelás cuando querés</div>

        <form onSubmit={handleSubmit}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>

            <div>
              <label style={labelStyle}>Nombre completo</label>
              <input type="text" placeholder="Juan Pérez" value={form.nombre}
                onChange={e => set('nombre', e.target.value)} required autoFocus style={inputStyle}
                onFocus={e => e.target.style.borderColor = L.blue}
                onBlur={e => e.target.style.borderColor = L.graphite}
              />
            </div>

            <div>
              <label style={labelStyle}>Nombre del estudio</label>
              <input type="text" placeholder="Estudio Jurídico Pérez" value={form.nombreEstudio}
                onChange={e => set('nombreEstudio', e.target.value)} required style={inputStyle}
                onFocus={e => e.target.style.borderColor = L.blue}
                onBlur={e => e.target.style.borderColor = L.graphite}
              />
            </div>

            <div>
              <label style={labelStyle}>Email</label>
              <input type="email" placeholder="juan@ejemplo.com" value={form.email}
                onChange={e => set('email', e.target.value)} required style={inputStyle}
                onFocus={e => e.target.style.borderColor = L.blue}
                onBlur={e => e.target.style.borderColor = L.graphite}
              />
            </div>

            <div>
              <label style={labelStyle}>Contraseña</label>
              <input type="password" placeholder="Mínimo 6 caracteres" value={form.password}
                onChange={e => set('password', e.target.value)} required style={inputStyle}
                onFocus={e => e.target.style.borderColor = L.blue}
                onBlur={e => e.target.style.borderColor = L.graphite}
              />
            </div>

            <div>
              <label style={labelStyle}>Repetir contraseña</label>
              <input type="password" placeholder="••••••••" value={form.password2}
                onChange={e => set('password2', e.target.value)} required style={inputStyle}
                onFocus={e => e.target.style.borderColor = L.blue}
                onBlur={e => e.target.style.borderColor = L.graphite}
              />
            </div>

          </div>

          {error && (
            <div style={{ background: 'rgba(239,68,68,0.08)', border: '0.5px solid rgba(239,68,68,0.25)', color: '#f87171', borderRadius: 6, padding: '10px 12px', fontSize: 13, marginTop: 16, letterSpacing: '-0.011em' }}>
              {error}
              {error.includes('ya tiene una cuenta') && (
                <button type="button" onClick={() => navigate('/app')} style={{ display: 'block', marginTop: 6, background: 'none', border: 'none', color: L.blue, fontSize: 12, cursor: 'pointer', padding: 0, fontWeight: 510, fontFamily: inter }}>
                  Ingresar →
                </button>
              )}
            </div>
          )}

          <button type="submit" disabled={loading} style={{
            width: '100%', marginTop: 20,
            background: L.blue, color: L.paper, border: 'none',
            borderRadius: 6, padding: '12px',
            fontSize: 14, fontWeight: 510, cursor: loading ? 'not-allowed' : 'pointer',
            opacity: loading ? 0.7 : 1, letterSpacing: '-0.011em', fontFamily: inter,
            transition: 'background 0.15s',
          }}
            onMouseEnter={e => { if (!loading) e.currentTarget.style.background = L.blueDim; }}
            onMouseLeave={e => e.currentTarget.style.background = L.blue}
          >
            {loading ? 'Creando tu estudio...' : 'Crear mi estudio gratis'}
          </button>

          <div style={{ textAlign: 'center', marginTop: 16, fontSize: 12, color: L.fog, letterSpacing: '-0.011em' }}>
            ¿Ya tenés cuenta?{' '}
            <button type="button" onClick={() => navigate('/app')} style={{ background: 'none', border: 'none', color: L.blue, cursor: 'pointer', fontSize: 12, fontWeight: 510, padding: 0, fontFamily: inter }}>
              Ingresar
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
